<script setup lang="ts">
import {computed} from "vue";
import JobsPanelSearch from "@/components/main/jobs-panel/JobsPanelSearch.vue";
import JobsPanelList from "@/components/main/jobs-panel/JobsPanelList.vue";
import AppLoader from "@/components/common/AppLoader.vue";
import AppIcon from "@/components/ui-kit/icon/AppIcon.vue";
import {jobsStore} from "@/store/jobs";
import {useJobsAccess} from "@/composables/useJobsAccess";

const store = jobsStore()

const isLoading = computed(() => store.jobsLoading)

const {isJobsDenied, deniedText} = useJobsAccess()

const loaderStyle = computed(() => ({
	'background-color': 'rgba(255, 255, 255, 0.5)'
}))
</script>

<template>
	<div class="jobs-panel">
		<app-loader v-if="isLoading" :style="loaderStyle"/>
		<div 
			v-if="isJobsDenied" 
			class="jobs-panel__no-access"
		>
			<app-icon
				class="jobs-panel__no-access-icon"
				name="invalid"
				width="24px"
				color="#979797"
			/>
			<div class="jobs-panel__no-access-label">
				{{ deniedText }}
			</div>
		</div>
		<template v-else>
			<jobs-panel-search />
			<jobs-panel-list />
		</template>
	</div>
</template>

<style scoped lang="scss">
.jobs-panel {
	display: flex;
	flex-direction: column;
	position: relative;
	max-height: 100%;
	height: 100%;
	width: 100%;
	background: #fff;
	border-radius: 12px;

	&:hover :deep(.app-scroll-top--enabled) {
		opacity: 1;
		visibility: visible;
		pointer-events: auto;
	}

	&__no-access {
		display: flex;
		flex: 1;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		padding: 24px;
		text-align: center;

		&-label {
			color: #979797;
			font-size: 16px;
			font-weight: 600;
			line-height: 20px;
		}
	}
}
</style>
